import {
  GET_COIN,
  GET_FUTURE_MARKETS,
  GET_FUTURE_MARKETS_ERROR,
  GET_COIN_ERROR,
  REMOVE_OLD_COIN,
  PRECISION_PRICE,
  ALL_FUTURE_MARKETS,
  PRECISION_PRICE_ERROR,
  ALL_PRECISION_PRICE_ERROR,
  FETCH_BOT_LIST,
  FETCH_BOT_LIST_ERROR,
  GET_BALANCE,
  CREATE_BOT_ERROR,
} from '../types';

const initialState = {
  symbol: [],
  loading: true,
  coin: [],
  market: '',
  exchange: '',
  esymbol: '',
  freeBots: null,
  activeBots: null,
  futureMarketsDetails: {},
  allFutureMarkets: [],
  botList: [],
  balance: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CREATE_BOT_ERROR:
      return {
        ...state,
        freeBots: action.payload.free,
        activeBots: action.payload.used,
        loading: false,
      };

    case GET_FUTURE_MARKETS:
      return {
        ...state,
        loading: false,
        symbol: action.payload,
      };

    case GET_BALANCE:
      return {
        ...state,
        loading: false,
        balance: action.payload,
      };

    case FETCH_BOT_LIST:
      return {
        ...state,
        loading: false,
        botList: action.payload,
      };

    case GET_FUTURE_MARKETS_ERROR:
      return {
        ...state,
        loading: true,
      };

    case FETCH_BOT_LIST_ERROR:
      return {
        ...state,
        loading: true,
      };

    case GET_COIN:
      return {
        ...state,
        loading: false,
        coin: action.payload,
      };

    case PRECISION_PRICE:
      return {
        ...state,
        loading: false,
        futureMarketsDetails: {
          exchange: action.payload.exchange,
          market: action.payload.market,
          coin: action.payload.coin,
          symbol: action.payload.symbol,
          esymbol: action.payload.esymbol,
          lastPrice: action.payload.lastPrice,
          min: action.payload.min,
          pricePrecision: action.payload.pricePrecision,
          quantityPrecision: action.payload.quantityPrecision,
          fundingRate: action.payload.fundingRate,
        },
      };

    case ALL_FUTURE_MARKETS:
      return {
        ...state,
        loading: false,
        allFutureMarkets: action.payload,
      };

    case ALL_PRECISION_PRICE_ERROR:
      return {
        ...state,
        loading: true,
      };

    case REMOVE_OLD_COIN:
      return {
        ...state,
        coin: action.payload,
      };

    case GET_COIN_ERROR:
      return {
        ...state,
        loading: true,
      };

    case PRECISION_PRICE_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
